import { defineComponent, PropType, ref, watch } from "vue";
import {
    useFetch,
    Member,
} from "../../../utils.js";
import { TimeRangeParams } from "../timeRange.js";
import { VoiceEntryWithUser } from "../types.js";
import { VoiceSessionsCard } from "../voice/VoiceSessionsCard.js";
import { createInteractionVoiceSessionItems } from "../voice/sessionModel.js";

export default defineComponent({
    name: "UserVoiceMenu",
    props: {
        userId: {
            type: String,
            required: true,
        },
        timeRange: {
            type: Object as PropType<TimeRangeParams>,
            required: true,
        },
        limit: {
            type: Number,
            default: 50,
        },
    },
    setup(props) {
        const { fetch } = useFetch();
        const entries   = ref<VoiceEntryWithUser[]>([]);
        const members   = ref<Map<string, Member>>(new Map());
        const loading   = ref<boolean>(true);

        async function load() {
            loading.value = true;

            try {
                const url = `/api/voice-interactions?userId=${props.userId}&before=${props.timeRange.before}&after=${props.timeRange.after}&limit=${props.limit}`;
                const res = await fetch(url).then((r) => r.json());

                const memberMap = new Map<string, Member>();
                for (const [ id, member ] of res.members || [])
                    memberMap.set(id, member as Member);

                entries.value = res.result || [];
                members.value = memberMap;
            } finally {
                loading.value = false;
            }
        }

        watch(() => [ props.userId, props.timeRange.key, props.limit ], load, { immediate: true });

        return () => {
            if (loading.value)
                return <div class="notice">Chargement…</div>;

            return (
                <VoiceSessionsCard
                    title="Sessions avec les autres"
                    emptyText="Aucune interaction sur la période sélectionnée."
                    currentUserId={props.userId}
                    timeRange={props.timeRange}
                    sessions={createInteractionVoiceSessionItems(props.userId, entries.value, members.value)}
                />
            );
        };
    },
});
